export default {
    cart(state) {
        return state.cart
    },
    checkAllFlag(state) {
        return state.checkAllFlag
    },
    selectedNum(state) {
        return state.selectedNum
    },
    isLogin(state) {
        return state.isLogin
    },
    delFlag(state) {
        return state.delFlag
    },
    user(state) {
        return state.user
    },
    player(state) {
        return state.player
    },
    userTypeNum(state) {
        return state.userTypeNum
    },
    newAddGoodsNum(state) {
        return state.newAddGoodsNum
    }
}


// WEBPACK FOOTER //
// ./src/store/getters.js